module.exports = __webpack_public_path__ + "static/media/1POLICY45.9a95938b.jpg";